export type QaAutoJoinConfig = {
  roomId: string;
  name: string;
};

export type InitialSceneKey = 'lobby' | 'ban-bang-phi';

export function resolveInitialScene(locationLike: Pick<Location, 'search'>): InitialSceneKey {
  const params = new URLSearchParams(locationLike.search);
  const directQaGameplay = params.get('qa') === 'game' && params.get('autojoin') !== '1';
  return directQaGameplay ? 'ban-bang-phi' : 'lobby';
}

export function resolveQaAutoJoin(locationLike: Pick<Location, 'search'>): QaAutoJoinConfig | null {
  const params = new URLSearchParams(locationLike.search);
  if (params.get('qa') !== 'game' || params.get('autojoin') !== '1') return null;

  const roomId = (params.get('room') ?? 'R07-QA').trim() || 'R07-QA';
  const name = (params.get('name') ?? 'QA Player').trim() || 'QA Player';
  return { roomId, name };
}
